import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import 'katex/dist/katex.min.css';
import { BlockMath } from 'react-katex';
import {
  getAllCourseDetails,
  getAllSubjectDetails,
  getAllChapterDetails,
  getCourseContentJson,
} from '../Servies/AdmiServices';
import Loader from '../components/common/Loader';
import CourseStructureTree from './CourseStructureTree';

export default function SelectCourseAndSubject() {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [quizTags, setQuizTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [Courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');
  const [selectedChapter, setSelectedChapter] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCourseChange = async () => {
    try {
      setLoading(true);
      const courseDetails = await getAllCourseDetails();
      const courseData = courseDetails?.data?.map(({ courseDisplayName, courseId }) => ({
        courseName: courseDisplayName,
        courseId,
      }));
      setCourses(courseData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error fetching course details:', error);
    }
  };

  const handleSubjectChange = async (courseId) => {
    try {
      const subjectDetails = await getAllSubjectDetails(courseId);
      const subjectData = subjectDetails?.data?.map(({ levelDisplayName, levelId }) => ({
        subjectName: levelDisplayName,
        levelId,
      }));
      setSubjects(subjectData);
    } catch (error) {
      console.error('Error fetching subject details:', error);
    }
  };

  const handleChapterChange = async (courseId, subjectId) => {
    try {
      const chapterDetails = await getAllChapterDetails(courseId, subjectId);
      const chapterData = chapterDetails?.data?.map(({ levelDisplayName, levelId }) => ({
        chapterName: levelDisplayName,
        levelId,
      }));
      setChapters(chapterData);
    } catch (error) {
      console.error('Error fetching chapter details:', error);
    }
  };

  useEffect(() => {
    handleCourseChange();
  }, []);

  useEffect(() => {
    if (selectedCourse) {
      const selectedCourseObject = Courses.find((course) => course.courseName === selectedCourse);
      if (selectedCourseObject) {
        handleSubjectChange(selectedCourseObject.courseId);
      }
    }
  }, [selectedCourse, Courses]);

  useEffect(() => {
    if (selectedCourse && selectedSubject) {
      const selectedCourseObject = Courses.find((course) => course.courseName === selectedCourse);
      const selectedSubjectObject = subjects.find((subject) => subject.subjectName === selectedSubject);
      if (selectedCourseObject && selectedSubjectObject) {
        handleChapterChange(selectedCourseObject.courseId, selectedSubjectObject.levelId);
      }
    }
  }, [selectedCourse, selectedSubject, Courses]);

  // const handleDownload = async () => {
  //   if (!selectedSubject) {
  //     toast.error('Please select a subject.');
  //     return;
  //   }
  //   const selectedSubjectObject = subjects.find((subject) => subject.subjectName === selectedSubject);
  //   const selectedCourseObject = Courses.find((course) => course.courseName === selectedCourse);

  //   console.log(selectedSubjectObject)
  //   try {
  //     const res = await getCourseContentJson(selectedSubjectObject.levelId);
  //     const jsonData = res?.data.data;
  //     console.log(jsonData)

  //     if (!jsonData) {
  //       toast.error('No data found.');
  //       return;
  //     }

  //     const filteredData = jsonData.map((item) => ({
  //       'Content Code': item.contentCode,
  //       'Chapter Name': item.chapterName,
  //       'Topic Name': item.topicName,
  //       'Content Name': item.contentName,
  //       'FileUrl': item.fileUrl,
  //       'Pdf Url': item.pdfUrl,
  //       'Content Id': item.contentId,
  //       'Content Type Code': item.contentTypeCode,
  //       'LevelType': item.levelType,

  //     }));

  //     const fileName = `${selectedCourseObject.courseName}_${selectedSubjectObject.subjectName}.xlsx`;
  //     const wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(filteredData), 'Data');
  //     const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
  //     const blob = new Blob([s2ab(excelBuffer)], {
  //       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //     });
  //     saveAs(blob, fileName);
  //   } catch (err) {
  //     console.error('Error downloading file:', err);
  //   }
  // };
const handleDownload = async () => {
  const wb = XLSX.utils.book_new();
  const selectedCourseObject = Courses.find((course) => course.courseName === selectedCourse);

  if (!selectedCourseObject) {
    toast.error('Please select a course.');
    return;
  }

  // Case 1: If a single subject is selected
  if (selectedSubject) {
    console.log('selectect subject',selectedSubject);
    const selectedSubjectObject = subjects.find((subject) => subject.subjectName === selectedSubject);
    if (!selectedSubjectObject) {
      toast.error('Invalid subject selection.');
      return;
    }

    try {
      const res = await getCourseContentJson(selectedSubjectObject.levelId);
      const jsonData = res?.data?.data;

      if (!jsonData || jsonData.length === 0) {
        toast.error('No content data found.');
        return;
      }

      const filteredData = jsonData.map((item) => ({
        'Content Code': item.contentCode,
        'Chapter Name': item.chapterName,
        'Topic Name': item.topicName,
        'Content Name': item.contentName,
        'FileUrl': item.fileUrl,
        'Pdf Url': item.pdfUrl,
        'Content Id': item.contentId,
        'Content Type Code': item.contentTypeCode,
        'LevelType': item.levelType,
      }));

      const ws = XLSX.utils.json_to_sheet(filteredData);
      XLSX.utils.book_append_sheet(wb, ws, selectedSubjectObject.subjectName.slice(0, 31));
      toast.success(`Excel Downloaded for ${selectedSubjectObject.subjectName.slice(0, 31)}`, {
                position: toast.POSITION.TOP_RIGHT,
              });
            
    } catch (err) {
      console.error('Error fetching content:', err);
      toast.error('Failed to fetch subject data.');
      return;
    }
  } 
  // Case 2: If no subject is selected, download all subjects for selected course
  else {
    try {
      const subjectDetails = await getAllSubjectDetails(selectedCourseObject.courseId);
      const levels = subjectDetails?.data || [];

      if (levels.length === 0) {
        toast.error('No subjects found under this course.');
        return;
      }

      await Promise.all(
        levels.map(async (level) => {
          const subjectName = level.levelDisplayName;
          const levelId = level.levelId;

          try {
            const res = await getCourseContentJson(levelId);
            const jsonData = res?.data?.data;

            if (!jsonData || jsonData.length === 0) {
              console.warn(`No data found for subject: ${subjectName}`);
              return;
            }

            const filteredData = jsonData.map((item) => ({
              'Content Code': item.contentCode,
              'Chapter Name': item.chapterName,
              'Topic Name': item.topicName,
              'Content Name': item.contentName,
              'FileUrl': item.fileUrl,
              'Pdf Url': item.pdfUrl,
              'Content Id': item.contentId,
              'Content Type Code': item.contentTypeCode,
              'LevelType': item.levelType,
            }));

            const ws = XLSX.utils.json_to_sheet(filteredData);
            XLSX.utils.book_append_sheet(wb, ws, subjectName.slice(0, 31));
            
          } catch (err) {
            console.error(`Error fetching data for ${subjectName}`, err);
            toast.error(`Error fetching data for ${subjectName}`);
          }
        })
      );
       toast.success(`Excel Downloaded for ${selectedCourse}_AllSubjects`, {
                position: toast.POSITION.TOP_RIGHT,
              });
    } catch (err) {
      console.error('Error fetching subject list:', err);
      toast.error('Failed to fetch subjects.');
      return;
    }
  }

  // Generate and download the Excel file
  const fileName = selectedSubject
    ? `${selectedCourse}_${selectedSubject}_Content.xlsx`
    : `${selectedCourse}_AllSubjects_Content.xlsx`;

  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
  const blob = new Blob([s2ab(excelBuffer)], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, fileName);
};

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i += 1) {
      view[i] = s.charCodeAt(i) % 256;
    }
    return buf;
  };

  const handleSubmit = () => {
    if (selectedCourse && selectedSubject) {
      const selectedSubjectObject = subjects.find((subject) => subject.subjectName === selectedSubject);
      const selectedCourseObject = Courses.find((course) => course.courseName === selectedCourse);
      setLoading(true);
      fetch(
        `${process.env.REACT_APP_API_URL}/course/get-course-structure-with-content?courseId=${selectedCourseObject.courseId}&parentLevelId=${selectedSubjectObject.levelId}`
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error('Failed to fetch course structure');
          }
          return response.json();
        })
        .then((data) => {
          setData(data);
          setLoading(false);
        })
        .catch((err) => {
          setError(err.message);
          setLoading(false);
        });
    }
  };

  return (
    <>
      {loading && <Loader />}
      <ToastContainer />

      <Helmet>
        <title> Dashboard: Notifications </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Select Course And Subject to get Structure
          </Typography>
        </Stack>
 

        <form>
          <div className="main" style={{ display: 'flex' }}>
            <div className="col-md-3">
              <FormControl sx={{ m: 1, width: 270 }} size={'medium'}>
                <InputLabel>Courses</InputLabel>
                <Select
                  value={selectedCourse}
                  onChange={(e) => {
                      setSelectedCourse(e.target.value);
                      setSelectedSubject(''); // Reset subject
                      setChapters([]);        // (optional) Reset chapter too if needed
                    }}
                  input={<OutlinedInput label="Courses" />}
                >
                  {Courses.map((course) => (
                    <MenuItem key={course.courseId} value={course.courseName}>
                      {course.courseName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="col-md-3" style={{ marginLeft: '10px' }}>
              <FormControl sx={{ m: 1, width: 270 }} size={'medium'}>
                <InputLabel>Subject</InputLabel>
                <Select
                  value={selectedSubject}
                  onChange={(e) => setSelectedSubject(e.target.value)}
                  input={<OutlinedInput label="Subject" />}
                >
                  {subjects.map((subject) => (
                    <MenuItem key={subject.levelId} value={subject.subjectName}>
                      {subject.subjectName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              sx={{ width: '120px', height: '40px', marginTop: '10px' }}
            >
              Search
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDownload}
              sx={{ width: '120px', height: '40px', marginTop: '10px' }}
            >
              Excel
            </Button>
          </div>
        </form>

        <br />
        <div className="p-6">
          <CourseStructureTree data={data} />
        </div>
      </Container>
    </>
  );
}
